const TEAMS_QUERY_KEY = {
  Root: 'teams',
  List: 'list',
  Preview: 'preview',
  Detail: 'detail',
} as const;

export const teamsRootKey = [TEAMS_QUERY_KEY.Root] as const;

export function teamsListKey(
  filter?: string,
): readonly ['teams', 'list', string | null] {
  return [...teamsRootKey, TEAMS_QUERY_KEY.List, filter ?? null] as const;
}

export function teamsPreviewKey(
  filter?: string,
): readonly ['teams', 'preview', string | null] {
  return [...teamsRootKey, TEAMS_QUERY_KEY.Preview, filter ?? null] as const;
}

export function teamsDetailKey(
  teamId: string,
): readonly ['teams', 'detail', string] {
  return [...teamsRootKey, TEAMS_QUERY_KEY.Detail, teamId] as const;
}
